/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorMultiEdgesTransformation', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorMultiEdgesTransformationController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-multi-edges-transformation.html'),

      replace: true,

      link(scope, element, attrs) {},
    };
  },
]);
